import { render } from "./VCalendar.vue?vue&type=template&id=3be0a01c&ts=true"
import script from "./VCalendar.vue?vue&type=script&lang=ts"
export * from "./VCalendar.vue?vue&type=script&lang=ts"

import "./VCalendar.vue?vue&type=style&index=0&id=3be0a01c&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__